import Rest from '@services/Rest'

/**
 * criado para aceitar ou recusar solicitações de reembolso/fechamento de reclamações no erp
 * @typedef {NullService}
 */
export default class NullService extends Rest {
  /**
   * @type {String}
   */
  static resource = ''
}
